// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2aq4J","label":"LabeledBox_label__1uLB7"};